var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.083 13.944 2 7.722V5h19.185c1.405.086 4.615.61 6.222 2.01C29.417 8.76 30 10.51 30 12.647v7.454c0 2.852-2.722 5.12-4.278 5.768-1.244.519-2.852.692-3.5.713H17.88l-5.186-3.305 2.14 3.305H2V11.352l4.083 2.592zm1.491 7.778V10.055H21.12c.562 0 1.88.182 2.658.908s.756 2.852.648 3.824v4.602c0 1.166-.778 2.332-3.306 2.332H7.574z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDar);
export default __webpack_public_path__ + "static/media/DAR.0c9ddbe369e56d55d5ffef1a4cdf3a2c.svg";
export { ForwardRef as ReactComponent };